import UILabel from "components/ui/UILabel";
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
import * as Styled from "./styled";
import { TimelineEventStepStatus } from "./types";

const SuccessNode = styled(Styled.EventStepNode)`
  background: ${(props) => props.theme.colors.success};

  svg {
    height: 10px;

    * {
      stroke-width: 64px;
      stroke: currentColor;
    }
  }
`;

const PendingNode = styled(Styled.EventStepNode)`
  background: ${(props) => props.theme.colors.accent};
  color: ${(props) => props.theme.reverseColors.accent};

  svg {
    * {
      stroke-width: 16px;
      stroke: currentColor;
    }
  }
`;

const IncompleteNode = styled(Styled.EventStepNode)`
  box-shadow: 0 0 0 2px ${(props) => props.theme.colors.secondary} inset;
`;

interface Props {
  children?: React.ReactNode;
  status: TimelineEventStepStatus;
}

const StepNode: React.FC<Props> = ({ children, status }) => {
  switch (status) {
    case TimelineEventStepStatus.complete:
      return (
        <SuccessNode>
          <Icon name="checkmark" />
        </SuccessNode>
      );
    case TimelineEventStepStatus.pending:
      return (
        <PendingNode>
          <Icon name="ellipsis" size="sm" />
        </PendingNode>
      );
    // case TimelineEventStepStatus.incomplete:
    default:
      return (
        <IncompleteNode>
          <UILabel.Micro bold color="primary">
            {children}
          </UILabel.Micro>
        </IncompleteNode>
      );
  }
};

export default StepNode;
